/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/~/lodash/fp/placeholder.js
// module id = 12
// module chunks = 1